<!-- 用户组织-详情 -->
<template>
  <div id="detail_accountManage" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">{{ $route.query.id ? '用户详情' : '企业整体评价' }}</div>
    <!-- 基础信息 -->
    <div class="form_detail">
      <div v-if="accountItem.user">
        <div>上级用户名称</div>
        <div>{{ accountItem.user }}</div>
      </div>
      <div v-for="(item, i) in keyItems" :key="i">
        <div>{{ item.title }}</div>
        <div v-if="item.type == 'status'" class="nowrap" :class="item.class_status ? item.class_status[accountItem[item.key]] : ''">
          {{ item.text_status[accountItem[item.key]] ? item.text_status[accountItem[item.key]] : '--' }}
        </div>
        <div v-else-if="item.type == 'money'" class="nowrap">{{ `￥${common.formatNumber(accountItem[item.key])}` }}</div>
        <div v-else-if="item.type == 'time'" class="nowrap">{{ accountItem[item.key] ? moment(accountItem[item.key]).format('YYYY-MM-DD') : '--' }}</div>
        <div v-else-if="item.type == 'img'" class="nowrap"><img :src="accountItem[item.key]" width="60" height="60" /></div>
        <div v-else-if="item.type == 'selfNumber'" class="nowrap">
          {{ accountItem[item.key] != null ? accountItem[item.key] : '无限制' }}
        </div>
        <div v-else-if="item.type == 'file'" class="nowrap">
          <div v-if="accountItem[item.key]?.length > 0">
            <div v-for="(f, i) in accountItem[item.key]" :key="i" class="file nowrap" @click="handleFileViewing(f)">{{ f?.name }}</div>
          </div>
          <div v-else style="color: #909399">暂无附件</div>
        </div>
        <div v-else>{{ accountItem[item.key] ? accountItem[item.key] : '--' }}</div>
      </div>
      <div class="smallTitle">子用户列表</div>
      <div class="table">
        <el-table
          v-if="accountItem.userList && accountItem.userList.length"
          :data="accountItem.userList"
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          ref="table"
          row-key="id"
          :tree-props="{ children: 'userList' }"
          :expand-row-keys="expandedKeys"
          :key="orgTableKey">
          <el-table-column label="组织名称" width="220" show-overflow-tooltip>
            <template slot-scope="props">
              <span>{{ props.row.enterprieName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, i) in tableKeys_current"
            :key="i"
            :prop="item.key"
            :label="item.title"
            :sortable="item.sortable ? 'custom' : false"
            show-overflow-tooltip
            :min-width="item.width ? item.width : ''"
            :align="item.align ?? 'center'">
            <template slot-scope="props">
              <div v-if="item.type == 'status'" :class="item.class_status ? item.class_status[props.row[item.key]] : ''">
                {{ item.text_status[props.row[item.key]] ? item.text_status[props.row[item.key]] : '--' }}
              </div>
              <div v-else-if="item.type == 'money'" class="nowrap">{{ `￥${common.formatNumber(props.row[item.key])}` }}</div>
              <div v-else-if="item.type == 'time'" class="nowrap">{{ props.row[item.key] ? moment(props.row[item.key]).format('YYYY-MM-DD') : '--' }}</div>
              <div v-else class="nowrap">{{ props.row[item.key] ? props.row[item.key] : '--' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="200" align="center">
            <template #default="scope">
              <el-button type="text" @click.stop="handleShow(scope.row)">查看</el-button>
              <el-button type="text" @click.stop="addChild(scope.row)">新增子级</el-button>
              <el-button type="text" @click.stop="delData(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div v-else style="width: calc(100% - 50px); text-align: center">
          <img src="../../../assets/img/emptyData.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 表单按钮 -->
    <div v-if="$route.query.id" class="absoluteGrop">
      <el-button
        type="primary"
        plain
        @click="
          $router.push({
            path: '/accountPages/edit_org',
            query: { id: accountItem.id, ifEdit: true, tier: accountItem.tier },
          })
        "
        >编辑</el-button
      >
      <el-button v-if="accountItem.tier != currentUser.tier" type="danger" plain @click="delData()">删除</el-button>
      <el-button plain @click="$router.go(-1)">返 回</el-button>
    </div>
    <!-- 预览组件 -->
    <PreviewFile ref="previewFile"></PreviewFile>
  </div>
</template>
<script>
import moment from 'moment';
import PreviewFile from '../../../components/file-preview.vue';
export default {
  name: 'detail_accountManage',
  components: { PreviewFile },
  data() {
    return {
      moment: moment,
      accountItem: { userList: [] },
      // 信息字段
      keyItems: [
        { title: '用户名称', key: 'enterprieName' },
        { title: '注册邮箱', key: 'registerMail' },
        { title: '企业电话', key: 'enterpriePhone' },
        { title: '企业邮箱', key: 'enterprieMail' },
        { title: '企业LOGO', key: 'logo', type: 'file' },
        { title: '目前所涉及的行业', key: 'category' },
        { title: '统一社会信用代码', key: 'code' },
        { title: '企业地址', key: 'address' },
        { title: '注册时间', key: 'createTime', type: 'time' },
        { title: '企业联系人', key: 'enterprieContacts' },
        { title: '联系人电话', key: 'contactsPhone' },
        { title: '联系人邮箱', key: 'contactsMail' },
        { title: '企业法人', key: 'enterpriseLegalPerson' },
        { title: '法人联系方式', key: 'enterpriseLegalPersonPhone' },
        { title: '营业执照', key: 'businessLicense', type: 'file' },
        { title: '生成自评报告次数', key: 'selfNumber', type: 'selfNumber' },
        { title: '生成报告次数', key: 'expertNumber', type: 'selfNumber' },
        { title: '年度评审得分', key: 'score' },
        { title: '参与评审次数', key: 'count' },
      ],
      // 列表字段合集
      tableKeys_current: [
        { title: '子用户ID', key: 'id', width: 150 },
        { title: '子用户名称', key: 'enterprieName', width: 150 },
        { title: '目前所涉及的行业', key: 'category', width: 150 },
        { title: '最新评审得分', key: 'score', class: 'green', width: 150 },
      ],
      expandedKeys: [],
      orgTableKey: '', //解决组织树重新渲染问题
    };
  },
  created() {
    this.getInfo();
  },
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
  },
  methods: {
    // 获取信息
    getInfo() {
      this.$axios
        .post(`${process.env.BASE_URL}api/user/userInfo`, { id: this.$route.query.id || this.currentUser.id })
        .then((res) => {
          if (res.data.code == 200) {
            this.accountItem = res.data.data;
            let fileKes = ['logo', 'businessLicense'];
            fileKes.forEach((key, i) => {
              if (res.data.data[key] && res.data.data[key] != '') {
                this.$set(this.accountItem, key, JSON.parse(res.data.data[key]));
              }
            });
            if (this.accountItem.selfNumber == null) {
              this.accountItem.selfNumber = '无限制';
            }
            if (this.accountItem.expertNumber == null) {
              this.accountItem.expertNumber = '无限制';
            }
            if (this.accountItem.userList && this.accountItem.userList.length > 0) {
              this.accountItem.userList.forEach((e) => {
                if (e.userList && e.userList.length > 0) {
                  this.expandedKeys.push(e.id + '');
                }
              });
            }
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleShow(row) {
      const newUrl = this.$router.resolve({
        path: '/accountPages/detail_org',
        query: { id: row.id },
      }).href;
      window.location.href = newUrl;
    },
    // 新建子级
    addChild(row) {
      this.$router.push({
        path: '/accountPages/edit_org',
        query: { id: row.id, tier: row.tier, tierId: row.id, tierName: row.enterprieName },
      });
    },
    // 删除
    delData(item) {
      this.$msgbox({
        title: '删除用户',
        message: '是否确定删除该用户及其下子用户？',
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        // cancelButtonClass: "cancelBtn cancelSetWidth",
        // confirmButtonClass: "uniteBtn",
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            let that = this;
            this.$axios
              .post(`${process.env.BASE_URL}api/user/deleteUser`, { id: item.id })
              .then((res) => {
                if (res.data.code == 200) {
                  that.getInfo();
                  that.$message({
                    message: '已删除',
                    type: 'success',
                  });
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: 'error',
                  });
                }
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              })
              .catch(() => {
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              });
          } else {
            //确认弹窗还原&关闭
            instance.confirmButtonText = '确定';
            instance.confirmButtonLoading = false;
            done();
          }
        },
      })
        .then((action) => {})
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
            offset: 100,
          });
        });
    },
    // 预览
    handleFileViewing(file) {
      console.log('🚀 ~ file:', file);
      this.$refs.previewFile.openDrawer([file]);
    },
    // 列表-表头样式
    headerCellStyle(header) {
      if (header.column.order == 'ascending' || header.column.order == 'descending') {
        return { color: '#3D7BDC', fontSize: '14px', fontWeight: 400, background: '#f9fafb' };
      } else {
        return { color: '#617180', fontSize: '14px', fontWeight: 400, background: '#f9fafb' };
      }
    },
    // 列表-单元格样式
    cellStyle() {
      return {
        fontSize: '14px',
        color: '#111928',
        fontWeight: 500,
        padding: '8px 0px',
        background: '#f9fafb',
      };
    },
  },
};
</script>
<style lang="less" scoped>
.form_detail {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
  margin-bottom: 45px;
  color: #111928;
  > div {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #e5e7eb;
    > div {
      padding: 8px 15px;
    }
    > div:first-child {
      color: #6b7280;
      width: 18vh;
      position: relative;
      flex-shrink: 0;

      &::after {
        content: '';
        position: absolute;
        right: 0px;
        width: 2px;
        height: 60%;
        top: 20%;
        font-size: 20px;
        background: #e5e7eb;
      }
    }
    .file {
      text-decoration-line: underline;
      cursor: pointer;
    }
  }
  .smallTitle {
    padding: 8px 15px;
    color: #6b7280;
    width: 200px;
  }
  /deep/.el-table {
    background: #f9fafb;
  }
}
</style>
